import { StatefullValue } from '@meddev/fe-shared';
import { ApplicationType } from '@shared/core';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace McaAppActions {
    export class SetApplicationType {
        public static readonly type = '[McaApp] SetApplicationType';
        constructor(public readonly applicationType: ApplicationType) {}
    }

    export class SetStyle {
        public static readonly type = '[McaApp] SetStyle';
        constructor(public readonly styleUrl: StatefullValue<string | null>) {}
    }
}
